<template>
    <div class="animated fadeIn">
        <div>
            <b-card>
                <div slot="header">
                    <strong style="margin-left: 5px">Codelab Details in project "{{ activeProject.name }}"</strong>
                </div>

                <div role="tablist" class="tabbed-form">
                    <b-card no-body class="mb-1">
                        <b-card-header @click="toggleStep(0)" header-tag="header" class="p-1 form-step-name" role="tab">
                            <img src="../../assets/gcp-icons/step1.png" />
                            {{ tabs[0] }}
                        </b-card-header>
                        <b-collapse v-model="tabOpen[0]" visible role="tabpanel">
                            <b-card-body>
                                <b-form class="step-form">
                                    <b-form-group label="Name" :label-cols="2" :horizontal="true">
                                        <b-row>
                                            <b-col md="8"
                                                ><b-form-input
                                                    v-model="$v.codelabData.name.$model"
                                                    type="text"
                                                    ref="category-name"
                                                    placeholder="Enter the category name"
                                                ></b-form-input>
                                                <Feedback
                                                    :state="validateRef('codelabData.name', 0)"
                                                    invalid="This field is required"
                                                    valid="Name is valid"
                                                ></Feedback>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <b-form-group label="Category" :label-cols="2" :horizontal="true">
                                        <b-row>
                                            <b-col md="8">
                                                <v-select
                                                    class="text-nowrap"
                                                    v-model="category"
                                                    label="name"
                                                    placeholder="Select Category"
                                                    :options="categories"
                                                    id="category-multiselect"
                                                ></v-select>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <b-form-group
                                        label="Password-protection"
                                        label-for="password-protection"
                                        :label-cols="2"
                                        :horizontal="true"
                                    >
                                        <b-form-checkbox-group id="password-protection" class="pill-pushdown">
                                            <label
                                                class="switch switch-label switch-pill switch-primary"
                                                data-children-count="1"
                                            >
                                                <input
                                                    class="switch-input"
                                                    type="checkbox"
                                                    v-model="passwordProtection"
                                                />
                                                <span
                                                    class="switch-slider"
                                                    data-checked="On"
                                                    data-unchecked="Off"
                                                ></span>
                                            </label>
                                        </b-form-checkbox-group>
                                    </b-form-group>

                                    <b-form-group
                                        v-if="passwordProtection"
                                        label="Password"
                                        :label-cols="2"
                                        :horizontal="true"
                                    >
                                        <b-row>
                                            <b-col md="8">
                                                <b-form-input
                                                    v-if="showPassword"
                                                    v-model="$v.codelabData.password.$model"
                                                    type="text"
                                                    ref="codelab-password"
                                                    placeholder="Enter the password"
                                                ></b-form-input>
                                                <b-form-input
                                                    v-else
                                                    v-model="$v.codelabData.password.$model"
                                                    type="password"
                                                    ref="codelab-password"
                                                    placeholder="Enter the password"
                                                ></b-form-input>
                                                <Feedback
                                                    :state="validateRef('codelabData.password', 0)"
                                                    invalid="This field is required"
                                                    valid="Password is valid"
                                                ></Feedback>
                                            </b-col>
                                            <b-col>
                                                <b-form-checkbox-group id="password-show">
                                                    <label
                                                        class="switch switch-label switch-pill switch-primary switch-show-password"
                                                        data-children-count="1"
                                                    >
                                                        <input
                                                            class="switch-input"
                                                            type="checkbox"
                                                            v-model="showPassword"
                                                        />
                                                        <span
                                                            class="switch-slider"
                                                            data-checked="Show"
                                                            data-unchecked="Hide"
                                                        ></span>
                                                    </label> </b-form-checkbox-group
                                            ></b-col>
                                        </b-row>
                                    </b-form-group>

                                    <b-form-group
                                        label="Warsaw Analytics Members only"
                                        :label-cols="2"
                                        :horizontal="true"
                                    >
                                        <b-form-checkbox-group class="pill-pushdown">
                                            <label
                                                class="switch switch-label switch-pill switch-primary"
                                                data-children-count="1"
                                            >
                                                <input
                                                    class="switch-input"
                                                    type="checkbox"
                                                    v-model="$v.codelabData.warsawAnalyticsOnly.$model"
                                                />
                                                <span
                                                    class="switch-slider"
                                                    data-checked="On"
                                                    data-unchecked="Off"
                                                ></span>
                                            </label>
                                        </b-form-checkbox-group>
                                    </b-form-group>

                                    <b-row>
                                        <b-col>
                                            <Feedback
                                                v-if="checkPage[0]"
                                                :state="validateRef('codelabData', 0)"
                                                invalid="You need to finish this step before accessing the next one"
                                                valid="This step is complete"
                                            ></Feedback>
                                            <b-button
                                                @click="toggleStep(1)"
                                                :disabled="checkPage[0] && $v.codelabData.$invalid"
                                                variant="primary"
                                            >
                                                <i class="icon-check"></i> Next
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                    <b-card no-body class="mb-1">
                        <b-card-header
                            @click="toggleStep(1)"
                            :disabled="$v.codelabData.$invalid"
                            header-tag="header"
                            class="p-1 form-step-name"
                            role="tab"
                        >
                            <img src="../../assets/gcp-icons/step2.png" />
                            {{ tabs[1] }}
                        </b-card-header>
                        <b-collapse v-model="tabOpen[1]" visible role="tabpanel">
                            <b-card-body>
                                <b-form class="step-form">
                                    <b-form-group label="Name" :label-cols="2" :horizontal="true">
                                        <b-row>
                                            <b-col md="8"
                                                ><b-form-input
                                                    v-model="$v.docsData.url.$model"
                                                    disabled
                                                    type="text"
                                                    ref="google-docs-url"
                                                    placeholder="Enter the Google Docs URL"
                                                ></b-form-input>
                                                <Feedback
                                                    :state="validateRef('docsData.url', 0)"
                                                    invalid="This field is required"
                                                    valid="URL is valid"
                                                ></Feedback>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <Feedback :state="codelabError.state" :invalid="codelabError.message"></Feedback>

                                    <b-row>
                                        <b-col>
                                            <Feedback
                                                v-if="checkPage[0]"
                                                :state="validateRef('codelabData', 0)"
                                                invalid="You need to finish this step before accessing the next one"
                                                valid="This step is complete"
                                            ></Feedback>
                                            <b-button
                                                @click="updateCodelab"
                                                :disabled="checkPage[0] && $v.codelabData.$invalid"
                                                variant="primary"
                                            >
                                                <i class="icon-check"></i> Finish
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </b-card>
        </div>
        <Loading :loading="$store.state.loading.processing" :text="$store.state.loading.text"></Loading>
    </div>
</template>

<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import Feedback from '@/components/Feedback'
import Loading from '@/components/loading.vue'

import {validationMixin} from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'

import {mapGetters} from 'vuex'
import {filterDirty} from '@/shared/filterDirty.js'

export default {
    data() {
        return {
            tabs: ['Codelab settings', 'Google Docs Settings'],
            tabIndex: 0,
            codelabData: {
                name: '',
                password: '',
                warsawAnalyticsOnly: false,
            },
            docsData: {
                url: '',
            },
            passwordProtection: false,
            showPassword: false,
            codelabError: {
                state: true,
                message: '',
            },
        }
    },
    mixins: [validationMixin],
    validations: {
        codelabData: {
            name: {required},
            password: {
                required: requiredIf(function() {
                    return this.passwordProtection
                }),
            },
            warsawAnalyticsOnly: {},
        },
        docsData: {
            url: {
                required,
                docsUrl: string => {
                    const reg = /^https:\/\/docs.google.com\/document\/d\//
                    return reg.test(string)
                },
            },
        },
    },
    components: {
        Feedback,
        Loading,
    },
    computed: {
        ...mapGetters({
            activeProject: 'project/active',
            categories: 'category/categories',
        }),
        tabOpen() {
            return this.tabs.map((tab, index) => (index === this.tabIndex ? true : false))
        },
        category: {
            get() {
                return this.$store.state.category.active
            },

            set(value) {
                this.$store.commit('category/SET_CATEGORY', value)
            },
        },
    },
    async created() {
        this.$store.commit('loading/PROCESSING', `Fetching the Codelab...`)
        this.checkPage = this.tabs.map(el => false)
        await this.fetchCategories()
        await this.fetchCodelab()
        this.$store.commit('loading/PROCESSED')
    },
    methods: {
        async fetchCodelab() {
            const {id} = this.$route.params
            this.codelab = await this.$store.dispatch('codelab/fetchCodelab', id)

            this.codelabData = {
                name: this.codelab.name,
                password: this.codelab.password,
                warsawAnalyticsOnly: this.codelab.warsawAnalyticsOnly,
            }
            this.passwordProtection = !!this.codelabData.password
            this.docsData = {
                url: this.codelab.docUrl,
            }
            this.fetchedFormData = Object.assign({}, this.codelabData)
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        updateCodelab() {
            const formDirty = filterDirty(this.codelabData, this.$v.codelabData, this.fetchedFormData)
            if (Object.keys(formDirty).length > 0) {
                const data = {
                    codelabData: {
                        ...formDirty,
                        categoryId: this.category.id === this.codelab.categoryRef.id ? undefined : this.category.id,
                    },
                    id: this.codelab.id,
                }
                this.$store.commit('loading/PROCESSING', `Updating the Codelab...`)
                this.$store
                    .dispatch('codelab/updateCodelab', data)
                    .then(codelab => {
                        this.$store.commit('loading/PROCESSED')
                        this.$router.push({
                            path: '/codelabs',
                        })
                    })
                    .catch(exception => {
                        this.codelabError.state = false
                        this.codelabError.message = exception.response.data
                        this.$store.commit('loading/PROCESSED')
                    })
            } else {
                this.$router.push({
                    path: '/codelabs',
                })
            }
        },

        validateRef(ref) {
            const keys = ref.split('.')
            const validateField = keys.reduce((a, c) => {
                return a[c]
            }, this.$v)

            return validateField.$dirty ? !validateField.$invalid : null
        },

        toggleStep(step) {
            this.tabIndex = step
            this.$forceUpdate()
        },

        async fetchCategories() {
            const categories = await this.$store.dispatch('category/getCategories', this.activeProject.id)
            if (localStorage.activeCategoryId) {
                const activeCategory = categories.find(el => el.id === localStorage.activeCategoryId)
                if (activeCategory) {
                    this.$store.commit('category/SET_CATEGORY', activeCategory)
                }
            }
        },
    },
}
</script>

<style lang="scss">
.switch-show-password {
    width: 70px;
    padding-top: 5px;
    .switch-input:checked ~ .switch-slider::before {
        transform: translateX(42px);
    }
}

.pill-pushdown {
    padding-top: 5px;
}
</style>
